<div class="agpr-sortSidebar">
    <agpr-panel header="Briefings.sortTool.sidebar.sectionHeading">
        <div class="agpr-sortSidebar-actions">
            <agpr-button
                *ngIf="briefingCuratedMentions?.length > 0"
                class="agpr-sortSidebar-action"
                [id]="id + '.reorganizeMentionsButton'"
                label="Briefings.sortTool.reorganizeMentions"
                [style]="buttonTypes.tertiary"
                (click)="reorganizeMentions()"
            ></agpr-button>
            <agpr-button
                class="agpr-sortSidebar-action"
                [id]="id + '.addSectionButton'"
                label="Briefings.sortTool.addSection"
                [style]="buttonTypes.tertiary"
                (click)="openNewCuratedListDialog()"
            ></agpr-button>
        </div>
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        <ul
            [id]="id + '_blockList'"
            [dndDropzone]="['block']"
            dndEffectAllowed="move"
            (dndDrop)="onDropBlocks($event)"
            [class]="blockListClassName"
            [attr.aria-label]="'Briefings.sortTool.sidebar.sectionHeading' | localize"
            agprListKeyboardNavigation
            [list]="blocks"
        >
            <li
                dndPlaceholderRef
                class="agpr-drag-placeholder"
            ></li>
            <li
                *ngFor="let block of blocks; index as i;"
                class="agpr-sortSidebar-blockContainer agpr-contextMenu-parent"
                [dndDraggable]="i"
                dndType="block"
                dndEffectAllowed="move"
                (dndStart)="onDragStartBlocks(block, $event)"
                (dndEnd)="cleanupAfterDragCompleted($event)"
                [attr.aria-label]="block.type.label | localize"
                (keydown)="selectBlock(block, $event)"
                (click)="selectBlock(block)"
            >
                <div
                    class="agpr-sortSidebar-block"
                    [ngClass]="{
                        'agpr-sortSidebar-block--selected': block === selectedBlock,
                        'agpr-sortSidebar-block--visuallyHidden': draggingMentions
                    }"
                >
                    <ng-container *ngTemplateOutlet="section; context: {$implicit: block, index: i}"></ng-container>
                </div>
                <div
                    *ngIf="!draggingBlock"
                    class="agpr-sortSidebar-block agpr-drag-dropzone"
                    [ngClass]="{
                        'agpr-sortSidebar-block--selected': block === selectedBlock,
                        'agpr-sortSidebar-block--visuallyHidden': !draggingMentions
                    }"
                    [dndDisableIf]="block === selectedBlock || block.type.key !== curatedBlockKey"
                    [dndDropzone]="['mention']"
                    [dndDragoverClass]="'agpr-drag-dropzone--dragover'"
                    [dndAllowExternal]="true"
                    dndEffectAllowed="link"
                    (dndDrop)="onDropMentionsOnBlock($event, block)"
                >
                    <ng-container *ngTemplateOutlet="section; context: {$implicit: block, index: i}"></ng-container>
                </div>
            </li>
        </ul>
        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    </agpr-panel>
</div>

<ng-template #section let-block let-i="index">
    @if (block.isLayoutBlock) {
        <div class="agpr-sortSidebar-layoutBlock">
            <div class="agpr-sortSidebar-layoutBlockHeader">
                <span
                    class="agpr-sortBlock-layoutBlockIcon"
                    [ngClass]="block.type.icon"
                    aria-hidden="true"
                ></span>
                <span class="agpr-sortSidebar-layoutBlockType">{{ block.type.label | localize }}</span>
            </div>
            <div class="agpr-sortSidebar-layoutBlockColumns">
                @for (layoutColumn of block.blocks; track layoutColumn) {
                    <div class="agpr-sortSidebar-layoutBlockColumn">
                        @for (layoutBlockChild of layoutColumn; track layoutBlockChild) {
                            @if (!draggingBlock) {
                                <div
                                    class="agpr-sortSidebar-layoutBlockChild"
                                    [dndDisableIf]="layoutBlockChild === selectedBlock || layoutBlockChild.type.key !== curatedBlockKey"
                                    [dndDropzone]="['mention']"
                                    [dndDragoverClass]="'agpr-drag-dropzone--dragover'"
                                    [dndAllowExternal]="true"
                                    dndEffectAllowed="link"
                                    (dndDrop)="onDropMentionsOnBlock($event, layoutBlockChild)"
                                >
                                    <agpr-sort-tool-block
                                        [id]="id + '.layoutBlockChild_' + layoutBlockChild.id"
                                        [block]="layoutBlockChild"
                                        [selected]="layoutBlockChild === selectedBlock"
                                        (keydown)="selectBlock(layoutBlockChild, $event)"
                                        (click)="selectBlock(layoutBlockChild)"
                                    ></agpr-sort-tool-block>
                                </div>
                            } @else {
                                <div
                                    class="agpr-sortSidebar-layoutBlockChild"
                                >
                                    <agpr-sort-tool-block
                                        [id]="id + '.layoutBlockChild_' + layoutBlockChild.id"
                                        [block]="layoutBlockChild"
                                        [selected]="layoutBlockChild === selectedBlock"
                                        (keydown)="selectBlock(layoutBlockChild, $event)"
                                        (click)="selectBlock(layoutBlockChild)"
                                    ></agpr-sort-tool-block>
                                </div>
                            }
                        }
                    </div>
                }
            </div>
        </div>
    } @else if (block.type.key === briefingBlockTypes.COVERAGE_CURATOR) {
        <div class="agpr-sortSidebar-layoutBlock">
            <div class="agpr-sortSidebar-layoutBlockHeader">
                <span
                    class="agpr-sortBlock-layoutBlockIcon"
                    [ngClass]="block.type.icon"
                    aria-hidden="true"
                ></span>
                <span class="agpr-sortSidebar-layoutBlockType">{{ block.type.label | localize }}</span>
            </div>
            <div class="agpr-sortSidebar-layoutBlockColumns">
                <div class="agpr-sortSidebar-layoutBlockColumn">
                    @for (block of block.blocks; track block) {
                        @if (!draggingBlock) {
                            <div
                                class="agpr-sortSidebar-layoutBlockChild"
                                [dndDisableIf]="block === selectedBlock || block.type.key !== curatedBlockKey"
                                [dndDropzone]="['mention']"
                                [dndDragoverClass]="'agpr-drag-dropzone--dragover'"
                                [dndAllowExternal]="true"
                                dndEffectAllowed="link"
                                (dndDrop)="onDropMentionsOnBlock($event, block)"
                            >
                                <agpr-sort-tool-block
                                    [id]="id + '.layoutBlockChild_' + block.id"
                                    [block]="block"
                                    [selected]="block === selectedBlock"
                                    (keydown)="selectBlock(block, $event)"
                                    (click)="selectBlock(block)"
                                ></agpr-sort-tool-block>
                            </div>
                        } @else {
                            <div
                                class="agpr-sortSidebar-layoutBlockChild"
                            >
                                <agpr-sort-tool-block
                                    [id]="id + '.layoutBlockChild_' + block.id"
                                    [block]="block"
                                    [selected]="block === selectedBlock"
                                    (keydown)="selectBlock(block, $event)"
                                    (click)="selectBlock(block)"
                                ></agpr-sort-tool-block>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }

    @else {
        <agpr-sort-tool-block
            [id]="id + '.blockItem_' + i"
            [block]="block"
            [selected]="block === selectedBlock"
        ></agpr-sort-tool-block>
    }

    <div class="agpr-contextMenu top right">
        <agpr-button
            [id]="id + '_blockItem_' + i + '_moveUp'"
            class="{{ blockListItemMoveUpClassName }}"
            icon="fa-regular fa-arrow-up"
            [disabled]="!block.canMoveUp"
            tooltip="PageBuilder.briefings.blockIcon.moveUp"
            tooltipPosition="top"
            (click)="onMoveUp(block)"
            [style]="buttonTypes.contextMenu"
        >
        </agpr-button>
        <agpr-button
            [id]="id + '.blockItem_' + i + '.moveDown'"
            class="{{ blockListItemMoveDownClassName }}"
            [class.bottomRight]="block.type.key === curatedBlockKey"
            icon="fa-regular fa-arrow-down"
            [disabled]="!block.canMoveDown"
            tooltip="PageBuilder.briefings.blockIcon.moveDown"
            tooltipPosition="top"
            (click)="onMoveDown(block)"
            [style]="buttonTypes.contextMenu"
        >
        </agpr-button>
        <span *ngIf="block.type.key === curatedBlockKey || block.isLayoutBlock" class='agpr-spacer'></span>
        <agpr-button
            *ngIf="block.type.key === curatedBlockKey"
            [id]="id + '.blockItem_' + i + '.sort'"
            class="bottomLeft"
            icon="fa-regular fa-arrow-down-arrow-up"
            tooltip="PageBuilder.briefings.blockIcon.sort"
            tooltipPosition="top"
            (click)="selectBlock(block)"
            [style]="buttonTypes.contextMenu"
        >
        </agpr-button>
        <agpr-button
            *ngIf="block.type.key === curatedBlockKey || block.isLayoutBlock"
            [id]="id + '.blockItem_' + i + '.delete'"
            icon="fa-regular fa-duotone fa-trash-can"
            tooltip="PageBuilder.briefings.blockIcon.delete"
            tooltipPosition="top"
            (click)="onDelete(block)"
            [style]="buttonTypes.contextMenu"
        >
        </agpr-button>
    </div>
</ng-template>
